import { QueryClient } from '@tanstack/react-query';

/** O cliente das consultas, um só para a web inteira (antes criado em `main.tsx`). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
/*
 * A LISTA DE SIMULADOS NÃO É PEDIDA DUAS VEZES NA MESMA TELA (25/10/2026, desempenho). Vários componentes da mesma tela leem
 * `['simulations']` (no Por Simulado, a página e o aviso dos só acompanhados); com a validade 0, o que montava depois do
 * primeiro pedido voltar pedia de novo — ~0,5 s a mais. Com 5 s, a mesma tela usa a mesma resposta; ao gravar, quem grava
 * invalida a chave e a lista volta do servidor, como antes.
 */
queryClient.setQueryDefaults(['simulations'], { staleTime: 5_000 })
// O mesmo para as disciplinas (a lista de questões e o filtro dela leem a chave em momentos diferentes).
queryClient.setQueryDefaults(['subjects'], { staleTime: 5_000 })
/*
 * O RELATÓRIO "POR SIMULADO" ABERTO DIRETO (25/10/2026, desempenho 3): os pedidos começam antes de a tela montar
 * (`features/teacher/relatorios/adiantarPorSimulado.ts`), e a tela, ao montar, recebe a resposta que acabou de chegar —
 * sem validade, ela pediria de novo na montagem. Ao gravar, quem grava invalida a chave, como antes.
 */
for (const chave of ['simulation-stats', 'descriptor-performance']) queryClient.setQueryDefaults([chave], { staleTime: 5_000 });
